import { Component, computed, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../core/services/theme.service';
import { Navbar } from '../Components/navbar/navbar';
import { TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-mainlayout',
  imports: [RouterOutlet, Navbar, TranslateModule, NgOptimizedImage],
  templateUrl: './mainlayout.html',
  styleUrl: './mainlayout.scss',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class Mainlayout {
  protected translate = inject(TranslateService);
  private theme: ThemeService = inject(ThemeService);

  protected isMobile = signal<boolean>(window.innerWidth <= 768);

  protected onResize() {
    this.isMobile.set(window.innerWidth <= 768);
  }

  protected logoUrl = computed<string>(() =>
    this.theme.isDarkMode() ? 'assets/logos/myservy_blanco.png' : 'assets/logos/myservy_negro.png'
  );
}